<script>
import MixedGridFiltersItemList from '@phoenix/mixins/components/mixedGrid/MixedGridFiltersItemList';

export default {
  mixins: [MixedGridFiltersItemList],

  emits: ['onItemSelected'],

  computed: {
    value: {
      get() {
        const value = this.activeFilters[this.filter.id];
        if (Array.isArray(value)) {
          return value[0];
        }
        return value;
      },
      set(value) {
        this.$emit('onItemSelected', this.filter.id, value);
      },
    },
  },

  methods: {
    getInputId(item) {
      return `filtersub-desktop-${this.filter.id}-${item.value}`;
    },

    getRadioClasses(item) {
      return { radio: true, 'radio--disabled': this.itemIsGreyedOut(item) };
    },
  },
};
</script>

<template>
  <ul class="filters-list" data-cy="mixed-grid-filter-radio" :data-cy-filter-id="filter.id">
    <li v-for="item in filter.items" :key="item.value">
      <div :class="getRadioClasses(item)">
        <input
          :id="getInputId(item)"
          v-model="value"
          :data-cy="getInputId(item)"
          :data-property="filter.id"
          :data-value="item.value"
          :name="`filtersub-desktop-${filter.id}`"
          :value="item.value"
          class="radio__input"
          type="radio"
        />
        <label :for="getInputId(item)" :data-cy-filter-value="item.label" class="radio__label">
          {{ item.label }}
        </label>
      </div>
    </li>
  </ul>
</template>
